import '../less/accordion.less';
import AccordionComponent from 'global/dynamic-components/accordion/js/accordion.js';

export default AccordionComponent;
